module.exports = __webpack_public_path__ + "media/paliwa/hybrid-37714fcd.png";